import { render } from "./WebsiteForm.vue?vue&type=template&id=aca74cfa&scoped=true"
import script from "./WebsiteForm.vue?vue&type=script&lang=js"
export * from "./WebsiteForm.vue?vue&type=script&lang=js"

import "./WebsiteForm.vue?vue&type=style&index=0&id=aca74cfa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca74cfa"]])

export default __exports__